import styled from 'styled-components';

export const StationIdLabel = styled.p`
  font-size: 14px;
  color: black;
  text-align: center;

  margin: 0;
  padding: 0;
`;

export const CanvaWrapper = styled.div`
  display: none;
  width: 640px;
  height: 680px;

  padding: 20px 20px 0 20px;

  flex-direction: column;
  justify-content: center;
  gap: 10px;

  & > ${StationIdLabel} {
    font-size: 36px;
  }
`;
